import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { AirplaneFilled } from "@fluentui/react-icons";
import React from "react";
import { TimingData } from "../../models/flights/IFlightsCommon";
import { toHHMM } from "../../utils/common/DateHelperFunctions";
import { formatHeaderDisplayValue } from "../../utils/common/FormatHelper";
import CardHeader from "./CardHeader";
import { useCardStyles } from "./shared.styles";

interface TimingMilestonesCardProps {
  data: TimingData;
  className?: string;
}

const TimingMilestonesCard: React.FC<TimingMilestonesCardProps> = ({
  data,
  className,
}) => {
  const shared = useCardStyles();
  const local = useLocalStyles();

  return (
    <article className={mergeClasses(shared.container, className)}>
      <CardHeader
        icon={<AirplaneFilled />}
        title="Timing Milestones"
        primaryValue={formatHeaderDisplayValue(
          toHHMM(
            data.legType === "arrival"
              ? data.bestInBlockTime
              : data.bestOffBlockTime
          )
        )}
      />
      {data.legType === "arrival" && (
        <section className={shared.content}>
          <dl className={mergeClasses(shared.column, local.milestonesWrapper)}>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>SIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.sibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>EIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.eibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>CIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.cibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>TIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.tibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>PIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.pibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>AIBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.aibt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>ALDT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.aldt)}
              </dd>
            </div>
          </dl>
        </section>
      )}
      {data.legType === "departure" && (
        <section className={shared.content}>
          <dl className={mergeClasses(shared.column, local.milestonesWrapper)}>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>SOBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.sobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>EOBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.eobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>COBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.cobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>TOBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.tobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>POBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.pobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>AOBT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.aobt)}
              </dd>
            </div>
            <div className={mergeClasses(shared.row, local.row)}>
              <dt className={mergeClasses(shared.label, local.label)}>ATOT</dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {toHHMM(data.atot)}
              </dd>
            </div>
          </dl>
        </section>
      )}
    </article>
  );
};

export default TimingMilestonesCard;

const useLocalStyles = makeStyles({
  milestonesWrapper: {
    gap: "12px",
  },
  row: {
    gap: "24px",
  },
  label: {
    width: "40px",
    textAlign: "left",
    fontSize: tokens.fontSizeBase300,
  },
  value: {
    width: "45px",
    fontSize: tokens.fontSizeBase300,
  },
});
